import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { font_2xl } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const chartsGrid = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${spacing(6)};

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }

  @media (min-width: 2000px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`

export const chartPanel = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(4)};
  height: 390px;
  padding: ${spacing(6)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${cornerRadius};
  background: ${base_colorRaisedSurface};
`

export const chartTitle = css`
  ${font_2xl};
  color: ${text_colorTextPrimary};
  margin: 0;
  font-weight: 500;
`
